import { useAtomValue } from 'jotai';
import { consultationDataAtom } from '../../atoms';

export const useConsultationData = () => {
    const consultationData = useAtomValue(consultationDataAtom);
    return consultationData;
};
